import { render, staticRenderFns } from "./DocumentTypesPaginateComponent.vue?vue&type=template&id=28f462bc"
import script from "./DocumentTypesPaginateComponent.js?vue&type=script&lang=js&external"
export * from "./DocumentTypesPaginateComponent.js?vue&type=script&lang=js&external"
import style0 from "./DocumentTypesPaginateComponent.vue?vue&type=style&index=0&id=28f462bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports